import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, IAppConfig } from '@tcc-mono/shared/app-config';
import { BaseService } from '@tcc-mono/shared/data-access';
import { Ride } from '@tcc-mono/vandijk/shared/data-access/models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppRideService extends BaseService<Ride> {
  public constructor(
    _http: HttpClient,
    @Inject(APP_CONFIG) appConfig: IAppConfig
  ) {
    super(_http, appConfig);
    this.path = 'api/app/rides';
  }

  public addAnimal = (
    rideId: PropertyKey,
    body: any,
    override: boolean = false
  ) => {
    return this.postChild(
      body,
      `/${rideId.toString()}/add_animal?override=${override}`
    );
  };

  public getRvoInfo = (
    country_code: string,
    identification_number: string,
    animal_species?: string,
  ) => {
    return this.postChild(
      {
        country_code,
        identification_number,
        ...(animal_species ? { animal_species } : {}),
      },
      `/rvo/animal_info`
    );
  };

  public deleteAnimal = (rideId: PropertyKey, animalId: PropertyKey): Observable<unknown> => {
    return this.delete(rideId.toString(), `animals/${animalId.toString()}`);
  };
}
